import fetch from "@lib/fetch";

import { reactQueryInfiniteFetcherAdapter } from "../reactQueryFetcherAdapters";
import { conversationHistoryDetail } from "./constants";
import type { ConversationHistoryDetailResult, GetConversationHistoryDetailParams } from "./types";

export const getConversationHistoryDetail = reactQueryInfiniteFetcherAdapter(
  conversationHistoryDetail,
  (
    signal: AbortSignal,
    [params]: [GetConversationHistoryDetailParams],
    pageParam: string | null
  ): Promise<ConversationHistoryDetailResult> => {
    return fetch(
      `/${params.appGroupId}/conversational/conversations/${params.historyType}/${params.sessionId}`,
      "GET",
      { cursor: pageParam ?? undefined },
      { signal }
    );
  }
);
